import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EXPORT_INVESTORS } from '@/constants/permissions';
import { useDownloadInvestorContactsExport } from '@/hooks/react-query/useInvestors';
import { useAuth } from '@/hooks/useAuthHook';
import type { InvestorFilters } from '@/types/investor';

interface InvestorsExportButtonProps {
  filters: InvestorFilters;
}

export function InvestorsExportButton({ filters }: InvestorsExportButtonProps) {
  const { hasPermission } = useAuth();
  const exportContacts = useDownloadInvestorContactsExport();

  if (!hasPermission(EXPORT_INVESTORS)) {
    return null;
  }

  return (
    <Button
      variant="outline"
      className="gap-2"
      onClick={() => exportContacts.mutate(filters)}
      disabled={exportContacts.isPending}
    >
      <Download className="h-4 w-4" />
      {exportContacts.isPending ? 'Exporting...' : 'Export'}
    </Button>
  );
}
